export enum ProjectPolicyId {
    Passworddictionary = 'password-dictionary',
    Passwordhistory = 'password-history',
    Passwordstrength = 'password-strength',
    Passwordpersonaldata = 'password-personal-data',
    Passwordpwned = 'password-pwned',
    Passwordrotation = 'password-rotation',
    Sessionalert = 'session-alert',
    Sessionduration = 'session-duration',
    Sessioninvalidation = 'session-invalidation',
    Sessionlimit = 'session-limit',
    Userlimit = 'user-limit',
    Membershipprivacy = 'membership-privacy',
    Mfafactors = 'mfa-factors',
    Denyaliasedemail = 'deny-aliased-email',
    Denydisposableemail = 'deny-disposable-email',
    Denyfreeemail = 'deny-free-email',
    Denycorporateemail = 'deny-corporate-email',
    Passkey = 'passkey',
}
